<template>
  <q-tooltip
    class="tooltip-background"
    anchor="center right"
    self="center left"
    style="padding: 0 10px"
    data-testid="agent-message-tooltip-content"
  >
    <div class="tooltip-data ibf-h8">
      <q-list
        dark
        separator
      >
        <q-item
          v-for="error of messages.errors"
          v-show="messages.errors.length > 0 && messages.errors[0] !== ''"
          :key="error"
          class="flex items-center"
        >
          <incredi-legend
            :color="COLORS['System/app_error']"
            class="dot"
            :size="8"
          ></incredi-legend>
          <q-item-section class="gordita-400-11">{{ error }}</q-item-section>
        </q-item>
        <q-item
          v-for="message of messages.messages"
          v-show="messages.messages.length > 0 && messages.messages[0] !== ''"
          :key="message"
          class="flex items-center"
        >
          <incredi-legend
            :color="COLORS['System/app_warning']"
            class="dot"
            :size="8"
          ></incredi-legend>
          <q-item-section
            data-testid="agent-message-tooltip-item"
            class="gordita-400-11"
            >{{ message }}</q-item-section
          >
        </q-item>
      </q-list>
    </div>
  </q-tooltip>
</template>

<script>
import { IncrediLegend } from 'incredi-ui';
import COLORS from '@/design-system/colors.json';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AgentTooltip',
  components: { IncrediLegend },
  props: {
    messages: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return { COLORS };
  },
});
</script>

<style lang="scss" scoped>
.q-list--separator > .q-item-type + .q-item-type {
  border-top: 1px solid rgba(255, 255, 255, 0.24);
}
.q-item {
  min-height: 32px;
  padding: 2px;
}
.dot {
  margin-right: 8px;
}
</style>
